import { render, staticRenderFns } from "./selection-1.vue?vue&type=template&id=80546fba&scoped=true&"
import script from "./selection-1.vue?vue&type=script&lang=js&"
export * from "./selection-1.vue?vue&type=script&lang=js&"
import style0 from "./selection-1.vue?vue&type=style&index=0&id=80546fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80546fba",
  null
  
)

export default component.exports